import { motion } from "framer-motion";
import type { ReactNode } from "react";
import {
  DURATION,
  EASE_OUT_EXPO,
  stepVariants,
  usePrefersReducedMotion,
  type StepDirection,
} from "@/lib/motion";

type Props = {
  stepKey: number;
  direction: StepDirection;
  children: ReactNode;
  className?: string;
};

export function BookingStepTransition({ stepKey, direction, children, className }: Props) {
  const reducedMotion = usePrefersReducedMotion();

  if (reducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      key={stepKey}
      custom={direction}
      variants={stepVariants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        duration: DURATION.step,
        ease: EASE_OUT_EXPO,
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
